var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"components-field-set"},[_vm._t("legend",function(){return [_c('legend',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }